import React, { type HTMLAttributes } from 'react';
import classNames from 'classnames';
import { Locale } from '@fixter/i18n';
import { MegaNav } from '@/components/organisms/MegaNav';
import { useAppContext } from '@/contexts/AppContext';
import { CallUsNavButton } from '@/components/molecules/CallUsNavButton';
import { translations as vrmLookupModalTranslations } from '@/components/molecules/VrmLookupDumbModal/translations';
import { VrmLookupDumb } from '@/components/molecules/VrmLookupDumb';
import { translations as vrmLookupFormTranslations } from '@/components/molecules/VrmLookupDumb/translations';
import frTranslations from '@/server/translations/navigation/fr.json';
import enTranslations from '@/server/translations/navigation/en.json';
import { VrmLookupDumbModal } from '@/components/molecules/VrmLookupDumbModal';

import styles from './index.module.scss';

export interface PageTopMegaNavigationBarProps extends HTMLAttributes<HTMLDivElement> {
  readonly campaignId?: string;
}

/**
 * Templates have to be Server Components.
 * Might conditionally load components based on page context.
 */
export function PageTopMegaNavigationBar({
  campaignId,
  className,
  ...props
}: PageTopMegaNavigationBarProps): JSX.Element {
  const { locale } = useAppContext();

  const isEnGb = locale === Locale.EN_GB;
  const translations = isEnGb ? enTranslations : frTranslations;
  const callUsLink = {
    url: isEnGb ? '03308089527' : '0176390537',
    text: isEnGb ? '0330 808 9527' : '01 76 39 05 37',
  };
  const mainCtaText = isEnGb ? 'See our services' : 'Obtenir un devis';

  return (
    <div className={classNames(PageTopMegaNavigationBar.displayName, styles.component, className)} {...props}>
      <MegaNav showLoginLink translations={translations} dynamicBlogData={[]}>
        <CallUsNavButton
          className={styles.callUsCta}
          phoneNumber={callUsLink.url}
          buttonText={callUsLink.text}
        />
        <VrmLookupDumbModal
          className={styles.toggleButton}
          triggeredFrom={PageTopMegaNavigationBar.displayName}
          size="S"
          {...vrmLookupModalTranslations[locale].default}
          toggleButtonText={mainCtaText}
        >
          <VrmLookupDumb
            locale={locale}
            sku={undefined}
            campaignId={campaignId}
            {...vrmLookupFormTranslations[locale].default}
          />
        </VrmLookupDumbModal>
      </MegaNav>
    </div>
  );
}
PageTopMegaNavigationBar.displayName = 'PageTopMegaNavigationBar';
